import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

/** Anything OpenAPI-shaped; the renderer validates the detail, not us. */
export type OpenApiDocument = Record<string, unknown>;

export const OPENAPI_KEY = ['openapi'] as const;

/**
 * The tenant's own API document (RL-385).
 *
 * Fetched through `apiClient`, so it carries the logged-in user's bearer token —
 * which is the whole point: `/docs` is Swagger's own middleware, outside Nest's
 * guards, and is gated at the edge by a shared operator credential. Reading the
 * API of your own shop should not require an operator password.
 *
 * The document only changes when a new build is deployed, so it is cached hard
 * rather than refetched on every visit; it is also around a megabyte of JSON.
 */
export function useOpenApiDocument(enabled = true) {
  return useQuery({
    queryKey: OPENAPI_KEY,
    enabled,
    staleTime: 60 * 60_000,
    gcTime: 60 * 60_000,
    retry: false,
    queryFn: async (): Promise<OpenApiDocument> => {
      const res = await apiClient.get<OpenApiDocument>('/openapi');
      return res.data;
    },
  });
}
